import { isArray, isObject } from "lodash";

/**
 * Get the records to Grid - async action creators
 * Hanlde the dynamic action based on given action type to Pending, Fullfilled (Success), Rejected actions
 *
 * @return object
 */
export function getGridRecords(actionDetails) {
  const { url, actionType, queryParams, service } = actionDetails;
  return {
    types: [
      `${actionType}_PENDING`,
      `${actionType}_FULFILLED`,
      `${actionType}_REJECTED`,
    ],
    method: "GET",
    url: url,
    queryParams: { ...queryParams },
    payload: {},
    // service: "trnzOpenApi",
  };
}

export function getGridRecordsNew(actionDetails) {
  const { url, actionType, queryParams } = actionDetails;
  return {
    types: [
      `${actionType}_PENDING`,
      `${actionType}_FULFILLED`,
      `${actionType}_REJECTED`,
    ],
    method: "GET",
    url: url,
    queryParams: { ...queryParams },
    payload: {},
    service: "trnzOpenApi",
  };
}

export function getGridRecordPartner(actionDetails) {
  const { url, actionType, queryParams } = actionDetails;
  return {
    types: [
      `${actionType}_PENDING`,
      `${actionType}_FULFILLED`,
      `${actionType}_REJECTED`,
    ],
    method: "GET",
    url: url,
    queryParams: { ...queryParams },
    payload: {},
    service: "partnerApi",
  };
}

export function getGridRecordOther(actionDetails) {
  const { url, actionType, queryParams, service } = actionDetails;
  return {
    types: [
      `${actionType}_PENDING`,
      `${actionType}_FULFILLED`,
      `${actionType}_REJECTED`,
    ],
    method: "GET",
    url: url,
    queryParams: { ...queryParams },
    payload: {},
    service,
  };
}

export function getGridRecordOpenWithoutFilter(actionDetails) {
  const { url, actionType, queryParams } = actionDetails;
  return {
    types: [
      `${actionType}_PENDING`,
      `${actionType}_FULFILLED`,
      `${actionType}_REJECTED`,
    ],
    method: "GET",
    url: url,
    queryParams: { ...queryParams },
    payload: {},
    service: "trnzOpenApi",
  };
}

/**
 * Deleted a record from Grid - async action creators
 * Hanlde the dynamic action based on given action type to Pending, Fullfilled (Success), Rejected actions
 *
 * @return object
 */
export function deleteGridRecord(actionDetails) {
  let { url, actionType, id, idKey, deleteParams, service } = actionDetails;
  let params = {};

  if (deleteParams && isObject(deleteParams)) {
    params = deleteParams;
  } else if (id && idKey) {
    id = isArray(id) ? id : [id];
    params = { [idKey]: id };
  }

  return {
    types: [
      `${actionType}_PENDING`,
      `${actionType}_FULFILLED`,
      `${actionType}_REJECTED`,
    ],
    method: "DELETE",
    url: `${url}`,
    payload: {},
    data: params,
    service,
  };
}

/**
 * Record status updated - async action creators
 * Hanlde the dynamic action based on given action type to Pending, Fullfilled (Success), Rejected actions
 *
 * @return object
 */
export function statusUpdateGridRecord(actionDetails) {
  const { url, actionType, params } = actionDetails;
  return {
    types: [
      `${actionType}_PENDING`,
      `${actionType}_FULFILLED`,
      `${actionType}_REJECTED`,
    ],
    method: "PATCH",
    url,
    payload: {},
    data: params,
  };
}

export function getGridRecordAari(actionDetails) {
  const { url, actionType, queryParams } = actionDetails;
  return {
    types: [
      `${actionType}_PENDING`,
      `${actionType}_FULFILLED`,
      `${actionType}_REJECTED`,
    ],
    method: "GET",
    url: url,
    queryParams: { ...queryParams },
    payload: {},
    service: "aariApi",
  };
}
